import { useAuth } from "@/context/AuthContext";
import { Navigate } from "react-router-dom";

export function RoleRoute({ allow, children }) {
  const { user } = useAuth();
  if (!user) return null;
  if (!allow.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}
